import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'document',
  type: 'node--document',
  attributes: {
    uuid: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
    title: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'title',
    },
    commentary: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'commentary',
    },
    needed: {
      type: 'boolean',
      required: false,
      isArray: false,
      name: 'needed',
    },
    url: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'absolute_url',
    },
  },
  relationships: {
    documentNeeded: {
      type: 'node--document',
      required: false,
      isArray: false,
      name: 'document_needed',
    },
    documentType: {
      type: 'node--document_type',
      required: false,
      isArray: false,
      name: 'document_type',
    },
    file: {
      type: 'file--file',
      required: false,
      isArray: false,
      name: 'file',
    },
  },
};
export const DocumentService = createService(base, configuration, API_CONFIG.API);
export const DocumentModule = createModule(DocumentService, true);



// WEBPACK FOOTER //
// ./src/models/document.js